var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { SettingsGlobalTabs } from './GlobalTabs/SettingsGlobalTabs';
import styles from './SettingsModalContent.module.scss';
import LocalTabs from './LocalTabs/LocalTabs';
import TabsContent from './TabsContent/TabsContent';
import { useCurrentTheme, usePresets } from '../../../hooks/useCurrentTheme';
import { useActions } from '../../../hooks/useActions';
import { isEqualPreset } from './utils';
var SettingModalContent = function () {
    var theme = useCurrentTheme();
    var presets = usePresets();
    var _a = useActions(), setCurrentPreset = _a.setCurrentPreset, setNewPresetList = _a.setNewPresetList;
    useEffect(function () {
        var newListPresets = presets.slice();
        var isThemeEqualSomePreset = presets.some(function (_a) {
            var key = _a.key, value = _a.value;
            var isEqually = isEqualPreset(value, theme);
            if (isEqually) {
                setCurrentPreset(key);
            }
            return isEqually;
        });
        var customPresetIndex = newListPresets.findIndex(function (item) { return item.key === 'Custom'; });
        var customPreset = {
            is_mobile: false,
            key: 'Custom',
            value: theme,
        };
        if (customPresetIndex === -1 && !isThemeEqualSomePreset) {
            newListPresets.splice(0, 0, customPreset);
            setNewPresetList(newListPresets);
            setCurrentPreset('Custom');
        }
        if (customPresetIndex > -1 && !isThemeEqualSomePreset) {
            newListPresets[0] = customPreset;
            setNewPresetList(newListPresets);
            setCurrentPreset('Custom');
        }
    }, [theme]);
    return (_jsxs("main", __assign({ className: styles.contentWrapper }, { children: [_jsx(SettingsGlobalTabs, {}), _jsx(LocalTabs, {}), _jsx(TabsContent, {})] })));
};
export default SettingModalContent;
